import {connect} from "react-redux";
import OrdersPage from "./OrdersPage";
import * as ViewActions from "../actions/ViewActions";
import {withRouter} from "react-router";

export default connect(null, {...ViewActions})(withRouter(OrdersPage));